import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export type CompletedFrequencyType = {
  frequencyId: number[]
  clientServiceId: number | null
  siteServiceId: number | null
}

export const useFrequenciesStore = defineStore(
  'frequencies',
  () => {
    /** state */
    const previouslyCompleted = ref([] as CompletedFrequencyType[])

    /** getters */
    const isSelectedFrequencyDefault = computed(
      () => selectedFrequency.value.length === 0,
    )

    const selectedFrequency = ref([] as number[])

    /** actions */
    function setSelectedFrequency(value: number[]): void {
      selectedFrequency.value = value
    }

    function setCompleted(
      clientServiceId: number | null,
      siteServiceId: number | null,
      frequencyId: number,
    ) {
      const completionRecordExists = !!previouslyCompleted.value.find(
        (record) =>
          record.clientServiceId === clientServiceId &&
          record.siteServiceId === siteServiceId,
      )

      if (completionRecordExists) {
        previouslyCompleted.value.forEach((frequency) => {
          if (frequency.clientServiceId !== clientServiceId) {
            return null
          }

          frequency.frequencyId.push(frequencyId)
          frequency.frequencyId = [...new Set(frequency.frequencyId)]
        })
      } else {
        previouslyCompleted.value.push({
          clientServiceId: clientServiceId,
          frequencyId: [frequencyId],
          siteServiceId: siteServiceId,
        })
      }
    }

    function resetFrequencies() {
      previouslyCompleted.value = []
      selectedFrequency.value = []
    }

    return {
      isSelectedFrequencyDefault,
      previouslyCompleted,
      resetFrequencies,
      selectedFrequency,
      setCompleted,
      setSelectedFrequency,
    }
  },
  {
    persist: true,
  },
)
